import { mapGetters } from 'vuex'
import { DefaultValues, Document } from '@/mixins'
import { cloneDeep, compact } from 'lodash'
import ProgramCrudMixin from './ProgramCrudMixin'

const emptyProgram = ({
  is_amenagement: false,
  use_tranche: false,
  address: null,
  buildings: [],
  tranches: [],
  construction_data: {},
  construction_steps: [],
  descriptions: [],
  documents: [],
  notary_data: {},
  geometrician_data: {},
  architect_data: {},
  picture: {},
  pictures: [],
  promoteur: {},
  promoteur_data: {},
  program_params: {
    show_gfa: false
  },
  referents: [],
  tax_dispositifs: [],
  sales_mode: [],
  videos: [],
  permis: []
})

export default {
  name: 'ProgramMixin',
  mixins: [DefaultValues, Document, ProgramCrudMixin],
  data () {
    return {
      id: null,
      // set to true in the upper component that call this mixin all children components witch embed this Mixin
      isParent: false,
      submitLoading: false,
      loading: false,
      program: null,
      programAllotments: [],
      programOptions: [],
      programAccesses: [],
      programVisibility: 0,
      programReservations: [],
      programLots: [],
      programRemuneration: null,
      programRemunerationLoading: null,
      programDiffusion: null,
      filters: {}
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'isDistributeur', 'mgcEnabled', 'canUseBuyerSpace', 'brikxEnabled']),
    p () {
      return this.program
    },
    isAmenagement () {
      if (this.p && this.p.is_amenagement) {
        return this.p.is_amenagement
      } else {
        return false
      }
    },
    nameToUse () {
      if (this.p && this.p.is_amenagement) {
        return 'lotissement'
      } else {
        return 'Programme'
      }
    },
    permisToUse () {
      if (this.p && this.p.is_amenagement) {
        return 'PA'
      } else {
        return 'PC'
      }
    },
    programPk () {
      if (this.p) {
        return this.p.pk
      } else return null
    },
    // return current element, needed for Document Mixin
    documentEl () {
      return this.program
    },
    // return method for patch, needed for Document Mixin
    patchElement () {
      return this.patchProgram
    },
    programView () {
      return this.$route.name
    },
    // salesMode () {
    //   return this.p.sales_mode.map(x => (this.salemodeData[x]) ? this.salemodeData[x].label : x).join(', ')
    // },
    taxDispositifs () {
      return this.p.tax_dispositifs.map(x => (this.taxDispositifsData[x]) ? this.taxDispositifsData[x].label : x).join(', ')
    },
    brochureDocument () {
      if (this.p && this.p.documents && this.p.documents.length) {
        return compact([this.p.documents.find(x => x.destination && x.destination.includes('brochure'))])
      } else return []
    },
    reservationDocument () {
      if (this.p && this.p.documents && this.p.documents.length) {
        return compact([this.p.documents.find(x => x.destination && x.destination.includes('contrat_reservation'))])
      } else return []
    },
    programDiffusionSupportsNames () {
      if (this.isAdmin && this.isPromoteur && this.programDiffusion && this.programDiffusion.supports.length) {
        return this.programDiffusion.supports.map(x => x.name).join('\n')
      }
    },
    lotCount () {
      if (this.programLots && this.programLots.length) {
        let okStatus = ['available', 'optioned']
        return this.programLots.filter(x => okStatus.includes(x.status)).length
      } else return 0
    },
    programDocuments () {
      return this.p.documents.filter(x => x.destination && x.destination.includes('program'))
    },
    sruCustomText () {
      return `<p>La loi vous offre une faculté de rétractation dans le délai de dix jours à compter du lendemain de la
      première présentation de cette lettre. Cette faculté de rétractation doit être exercée au domicile élu dans
      l’avant contrat, par lettre recommandée avec demande d’accusé de réception.</p>
      <p>En cas de rétractation, les fonds versés vous seront restitués dans un délai de vingt et un jours à
      compter du lendemain de la date de rétractation, sur présentation de la copie de la notification de rétractation et de l’avis de réception.</p>
      <p>Les dispositions de l’article L 271-1 du Code de la construction et de l’habitation sont ci-après littéralement
      rapportées :</p>
      <p>« Pour tout acte ayant pour objet la construction ou l’acquisition d’un immeuble à usage d’habitation,
      la souscription de parts donnant vocation à l’attribution en jouissance ou en propriété d’immeubles d’habitation ou la
      vente d’immeubles à construire ou de location-accession à la propriété immobilière, l’acquéreur non professionnel peut
      se rétracter dans un délai de dix jours à compter du lendemain de la première présentation de la lettre lui notifiant l’acte.</p>
      <p>Cet acte est notifié à l’acquéreur par lettre recommandée avec demande d’avis de réception ou par tout autre moyen
      présentant des garanties équivalentes pour la détermination de la date de réception ou de remise. La faculté de rétractation est exercée dans ces mêmes formes.</p>
      <p>Lorsque l’acte est conclu par l’intermédiaire d’un professionnel ayant reçu mandat pour prêter son concours à la vente,
      cet acte peut être remis directement au bénéficiaire du droit de rétractation. Dans ce cas, le délai de rétractation
      cours à compter du lendemain de la remise de l’acte, qui doit être attesté selon les modalités fixées par décret.</p>
      <p>Lorsque le contrat constatant ou réalisant la convention est précédé d’un contrat préliminaire ou d’une promesse
      synallagmatique ou unilatérale, les dispositions figurants aux trois alinéas précédents ne s’appliquent qu’à ce contrat ou cette promesse.</p>
      <p>Lorsque le contrat constatant ou réalisant la convention est dressé en la forme authentique et n’est pas précédé
      d’un contrat préliminaire ou d’une promesse synallagmatique ou unilatérale, l’acquéreur non professionnel dispose
      d’un délai de réflexion de dix jours à compter de la notification ou de la remise du projet d’acte selon les mêmes
      modalités que celles prévues pour le délai de rétractation mentionné aux premier et troisième alinéas. En aucun cas l’acte authentique ne peut être signé pendant ce délai de dix jours. »</p>`
    },
    firstSectionAdf () {
      return `<p>Lettre recommandée avec accusé de reception</p>`
    },
    homePageSection () {
      return `<p>Nous vous prions de trouver sous ce pli, copie de(s) attestation(s) de l'architecte de la résidence</p>`
    },
    stepName () {
      return `<p>indiquant que l'opération est au stade d'avancement des travaux :</p>`
    },
    arrayBloc () {
      return `<p>Conformément à votre acquisition en l’état futur d’achèvement, vous trouverez ci-dessous le tableau
        de suivi de vos règlements.</p>`
    },
    amountStepAdf () {
      return `<p>En conséquence, nous vous remercions de bien vouloir nous faire parvenir votre
          règlement d'un </p>`
    },
    paymentModality () {
      return `<p>par :</p>
        <p>- Chèque : à l’ordre de la société </p>
        <p>- Virement : sur le compte bancaire dont vous
            trouverez ci-joint le RIB.</p>`
    }
  },
  props: {
    sourceProgram: Object,
    sourceProgramDiffusion: Object,
    sourceProgramOptions: {
      type: Array,
      default: () => []
    },
    sourceProgramAccesses: {
      type: Array,
      default: () => []
    },
    sourceProgramReservations: {
      type: Array,
      default: () => []
    },
    sourceProgramLots: {
      type: Array,
      default: () => []
    },
    sourceProgramAllotments: {
      type: Array,
      default: () => []
    },
    sourceLoading: {
      type: Boolean,
      default: false
    },
    sourceSubmitLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    sourceLoading (v) {
      this.loading = v
    },
    sourceSubmitLoading (v) {
      this.submitLoading = v
    },
    '$route.params.id' (to, from) {
      if (to && to !== from) {
        this.initView()
      }
    }
  },
  created () {
    this.initView()
  },
  methods: {
    async initView () {
      if (this.sourceProgram) {
        this.initProgram({ ...this.sourceProgram })
      } else if (this.$route.params.id) {
        this.id = this.$route.params.id
        await this.getProgram(this.id)
        if (this.program.gfa_defined_percentage === null) {
          this.program.gfa_defined_percentage = 50
        }
        if ('promoteur_custom_picture' in this.program.program_params && this.program.program_params.promoteur_custom_picture) {
          this.promoteur_custom_picture = [this.program.program_params.promoteur_custom_picture]
        }
        if (!('sru_custom_text' in this.program.program_params) || this.program.program_params.sru_custom_text == null) {
          this.program.program_params.sru_custom_text = this.sruCustomText
        }
        if (!('first_section_adf' in this.program.program_params) || this.program.program_params.first_section_adf == null) {
          this.program.program_params.first_section_adf = this.firstSectionAdf
        }
        if (!('home_page_section' in this.program.program_params) || this.program.program_params.home_page_section == null) {
          this.program.program_params.home_page_section = this.homePageSection
        }
        if (!('step_name' in this.program.program_params) || this.program.program_params.step_name == null) {
          this.program.program_params.step_name = this.stepName
        }
        if (!('array_bloc' in this.program.program_params) || this.program.program_params.array_bloc == null) {
          this.program.program_params.array_bloc = this.arrayBloc
        }
        if (!('amount_step_adf' in this.program.program_params) || this.program.program_params.amount_step_adf == null) {
          this.program.program_params.amount_step_adf = this.amountStepAdf
        }
        if (!('modality' in this.program.program_params) || this.program.program_params.modality == null) {
          this.program.program_params.modality = this.paymentModality
        }
        this.initProgram({ ...cloneDeep(this.program) })
      } else {
        this.newProgram = true
        this.initProgram({ ...cloneDeep(emptyProgram) })
        if (this.$route.params != null && 'isAmenagement' in this.$route.params && this.$route.params.isAmenagement === true) {
          this.program.is_amenagement = true
        }
      }
      if (this.programPk) {
        this.getProgramItems()
      }
      this.updateSources({
        options: this.sourceProgramOptions,
        reservations: this.sourceProgramReservations,
        lots: this.sourceProgramLots,
        accesses: this.sourceProgramAccesses,
        notes: this.sourceProgramNotes,
        allotments: this.sourceProgramAllotments,
        diffusion: this.sourceProgramDiffusion
      })
    },
    initProgram (program) {
      this.$set(this, 'program', program)
      if (this.initProgramForm && typeof this.initProgramForm === 'function') {
        this.initProgramForm()
      }
    },
    beforeSubmit (program) {
      program.force = true
      if ('contracts' in program) {
        program.contracts = program.contracts.map(x => x.pk)
      }
      return program
    },
    getProgramItems () {
      this.updateSources({ documents: this.p.documents })
      if (this.isDistributeur) {
        this.getProgramRemuneration()
      }
      if (!this.programLots.length) {
        this.getProgramLots()
      }
      if (this.isAdmin && this.isPromoteur && !this.programDiffusion && this.mgcEnabled) {
        this.getProgramDiffusion()
      }
      if (this.isPromoteur && !this.programAccesses.length) {
        this.getProgramAccesses()
      }
      if (this.isPromoteur && !this.programVisibility) {
        this.getProgramVisibility()
      }
      if (this.programView === 'ProgramOptions' && !this.programOptions.length) {
        this.getProgramOptions()
      }
      if (this.programView === 'ProgramReservations' && !this.programReservations.length) {
        this.getProgramReservations()
      }
    },
    updateSources ({ options = null, reservations = null, accesses = null, lots = null, allotments = null, remuneration = null, diffusion = null, visibility = null }) {
      if (options !== null) this.programOptions = options
      if (reservations !== null) this.programReservations = reservations
      if (accesses !== null) this.programAccesses = accesses
      if (lots !== null) this.programLots = lots
      if (allotments !== null) this.programAllotments = allotments
      if (remuneration !== null) this.programRemuneration = remuneration
      if (diffusion !== null) this.programDiffusion = diffusion
      if (visibility !== null) this.programVisibility = visibility
      if (!this.isParent) {
        this.$emit('updateSources', {
          options,
          reservations,
          accesses,
          lots,
          allotments,
          remuneration,
          diffusion,
          visibility
        })
      }
    },
    async deleteAccess (pk) {
      let value = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au programme, cette action entrainera également l\'annulation de ses options sur ce programme.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCESS, pk)
          this.$toasted.global.success('Mandat supprimé')
          await this.getProgramAccesses()
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    },
    async getProgramReservations () {
      let params = { program: this.programPk }
      try {
        let { data } = await this.$api.get(this.$resources.RESERVATION, params)
        this.updateSources({ reservations: data.items })
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramOptions () {
      let params = { program: this.programPk }
      try {
        let { data } = await this.$api.get(this.$resources.OPTION, params)
        this.updateSources({ options: data.items })
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramAccesses (perPage = 1) {
      let params = { program: this.programPk, per_page: perPage }
      try {
        let { data } = await this.$api.get(this.$resources.ACCESS, params)
        this.updateSources({ accesses: data.items })
        this.getProgramAllotments()
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramVisibility () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_VISIBILITY(this.programPk))
        this.updateSources({ visibility: data })
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramLots () {
      let params = { program: this.programPk, per_page: 200, ...this.filters }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.updateSources({ lots: data.items })
        if (this.formMode) {
          this.setLotByBuilding()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramDiffusion () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_MGC_PARAMS(this.programPk))
        this.updateSources({ diffusion: data })
      } catch (err) {
        console.log(err)
      }
    },
    async getProgramAllotments () {
      let params = { program: this.programPk }
      let { data } = await this.$api.get(this.$resources.ALLOTMENT, params)
      this.updateSources({ allotments: data.items })
    },
    async getProgramRemuneration () {
      this.programRemunerationLoading = true
      let params = { program: this.programPk }
      try {
        const { data } = await this.$api.get(this.$resources.ACCESS, params)
        let remuneration = data.items && data.items.length ? data.items[0] : null
        this.updateSources({ remuneration })
      } catch (e) {
        console.log(e)
      }
      this.programRemunerationLoading = false
    },
    setLotByBuilding () {
      if (!this.program.buildings || !this.program.buildings.length) return
      this.programLots.forEach(lot => {
        if (lot.building) {
          let idx = this.program.buildings.findIndex(x => lot.building.pk === x.pk)
          if (!this.program.buildings[idx].lots || !Array.isArray(this.program.buildings[idx].lots)) {
            this.program.buildings[idx].lots = []
          }
          let lotIdx = this.program.buildings[idx].lots.findIndex(x => x.pk === lot.pk)
          if (lotIdx < 0) {
            this.program.buildings[idx].lots.push(lot)
          }
        }
      })
    }
  }
}
